<script lang="ts">
import { useConfigStore, useUserStore } from '~/store'
import type { ApplicationService } from '~/services/application.service'
import defaultLogo from '@/assets/images/icon.png'

const configStore = useConfigStore()
const AppName = configStore.currentConfig?.app_info?.title || 'Commande de fichier Majic'
useHead({
    titleTemplate: `${AppName} - %s`,
})

export default {
    name: 'DefaultLayout',
    setup() {
        const configStore = useConfigStore()

        return {
            configStore,
        }
    },
    computed: {
        currentPage() {
            return this.$currentPath(this.$route.matched[0].path)[0]
            // return this.$refs && this.$refs.MenuBreadcrumbs && this.$refs.MenuBreadcrumbs.breadcrumbItems.slice(-1)
        },
        loading() {
            return useConfigStore()?.globalLoading
        },
        maintenance() {
            return useConfigStore()?.maintenance
        },
        currentUser() {
            return useUserStore()?.currentUser
        },
        iconUrl(): string {
            const appInfo = this.configStore.currentConfig?.app_info

            // 2. Check if appInfo AND a valid icon/image exist
            if (!appInfo && (appInfo.icon || appInfo.image)) {
                const iconPath = appInfo.icon ?? appInfo.image
                return `${this.$config.public.apiBase}/${iconPath}`
            }

            // 3. Failsafe (Return the default image)
            // Note: See the section below about handling static assets!
            return defaultLogo
        },
    },
    watch: {
        async currentUser(newValue) {
            if (newValue.id) {
                const applicationService = this.$applicationService as ApplicationService
                // loading Application data
                await applicationService.init()
            }
        },
    },
    async mounted() {
        this.configStore.currentConfig.app_info = await this.getAppInfo()
        useConfigStore().setGlobalLoading(false)
        this.configStore.currentConfig.homepage_view = 'connexion'
        if (this.currentUser.k) {
            const applicationService = this.$applicationService as ApplicationService
            // loading Application data
            await applicationService.init()
        }
    },
    methods: {
        async getAppInfo(): Promise<[]> {
            const config = useRuntimeConfig()
            const res = await this.$api.setRequest({
                url: `applications`,
                query: { slug: config.public.app_slug },
                method: 'GET',
            })
            if (res?.data)
                return res.data[0]
            return []
        },
    },
}
</script>

<template>
    <v-layout>
        <MenuGlobalLoader :loading="loading">
            <template #loader>
                <svg viewBox="25 25 50 50">
                    <circle
                        class="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke="#636363"
                        stroke-width="2"
                    />
                </svg>
            </template>
            <template #logo />
        </MenuGlobalLoader>

        <MenuMaintenanceMessage>
            <template #logo />
        </MenuMaintenanceMessage>

        <client-only>
            <v-main
                v-if="!maintenance && !loading"
                id="main-content"
                class="bg-custom-light"
            >
                <header>
                    <MenuAppBar :disable-navigation="true" :elevation="0">
                        <template #title>
                            <v-row align="center">
                                <v-col cols="3" md="3" lg="2" class="text-center">
                                    <img
                                        v-if="iconUrl"
                                        class="w-auto pt-1 logo"
                                        :src="iconUrl"
                                        alt="Pildom logo"
                                        height="70"
                                        @click="$router.push('/')"
                                    >
                                </v-col>
                                <v-col v-if="$vuetify.display.mdAndUp" cols="9">
                                    {{ configStore.currentConfig?.app_info?.title }}
                                </v-col>
                            </v-row>
                        </template>
                        <template #rightMenu>
                            <MenuAppbarUserProfile>
                                <template #loginbuttons>
                                    <v-btn
                                        class="mx-2"
                                        variant="outlined"
                                        @click="configStore.currentConfig.homepage_view = 'connexion'"
                                    >
                                        Connexion
                                    </v-btn>
                                    <v-btn
                                        class="mx-2"
                                        variant="outlined"
                                        @click="configStore.currentConfig.homepage_view = 'register'"
                                    >
                                        Créer un compte
                                    </v-btn>
                                </template>
                            </MenuAppbarUserProfile>
                        </template>
                    </MenuAppBar>
                </header>
                <!-- TO DO : bg-primary lorsque l'utilisateur n'est pas connecté ou en attente d'acceptation  :class="$currentUser()" -->
                <div id="page-content" class="pa-6" :class="$hasAccess($config.public.app_slug) ? 'bg-light' : 'bg-primary'">
                    <!--                    <div id="page-header" class="mb-4"> -->
                    <!--                        <Breadcrumbs v-if="$route.path !== '/' || $hasAccess($config.public.app_slug)" /> -->
                    <!--                        <h1 -->
                    <!--                            v-if="currentPage" -->
                    <!--                            class="text-h4" -->
                    <!--                        > -->
                    <!--                            {{ $translate(currentPage.title) }} -->
                    <!--                        </h1> -->
                    <!--                    </div> -->
                    <!-- <MenuGlobalAlert /> -->
                    <NuxtPage />
                    <Toaster />
                </div>
                <MenuFooter color="primary" />
            </v-main>
        </client-only>
    </v-layout>
</template>
